const INITIAL_STATE = {
    newResources: [],
    newResource: {},
    count: 0,
    loading: false
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case "GET_NEW_RESOURCES": {
            return {
                ...state,
                newResources: action.data,
                count: action.count,
                loading: false
            }
        }
        case "GET_NEW_RESOURCE": {
            return {
                ...state,
                newResource: action.data,
                loading: false
            }
        }
        default:
            return state
    }
}
